import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import React from "react";
import { scopeTableCols } from "./scopeTableCols";
import { lightTable } from "../../../../../../../../../styles/muiProps";
import { Box, Button } from "@mui/material";
import NumberedTitle from "../../shared/NumberedTitle";

import AddBoxIcon from "@mui/icons-material/AddBox";
import DeleteIcon from "@mui/icons-material/Delete";
import { useMRQContext } from "../../MRQContext";

export default function ScopeTable() {
  const { mrqData, onChangeCell } = useMRQContext();
  const [mrqScope, setMrqScope] = React.useState(mrqData?.mrqScope || []);

  React.useEffect(() => {
    setMrqScope(mrqData?.mrqScope || []);
  }, [mrqData]);

  const table = useMaterialReactTable({
    data: mrqScope,
    columns: scopeTableCols,
    ...lightTable,
    enableStickyHeader: true,
    enableEditing: true,
    editDisplayMode: "row",
    createDisplayMode: "row",

    enableRowActions: true,
    positionActionsColumn: "last",

    muiEditTextFieldProps: {
      variant: "standard",
      size: "small",
      fullWidth: true,
    },

    onEditingRowSave: ({ values, row, table }) => {
      setMrqScope((prev) =>
        prev.map((item, index) => (index === row.index ? values : item)),
      );
      table.setEditingRow(null);
    },

    onCreatingRowSave: ({ values, table }) => {
      setMrqScope((prev) => [...prev, values]);
      table.setCreatingRow(null);
    },

    muiTableContainerProps: { sx: { maxHeight: "400px" } },

    enableRowSelection: true,
  });

  const handleDeleteSelected = () => {
    const selectedRows = table.getSelectedRowModel().rows;

    setMrqScope((prev) =>
      prev.filter(
        (_, index) => !selectedRows.some((row) => row.index === index),
      ),
    );

    table.resetRowSelection();
  };

  return (
    <div style={{ marginTop: "5px", width: "100%" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <NumberedTitle number="1" title="Scope" />

        <Box display="flex" gap={1}>
          <Button
            onClick={() => table.setCreatingRow(true)}
            variant="contained"
            startIcon={<AddBoxIcon />}
          >
            Add
          </Button>

          <Button
            variant="contained"
            startIcon={<DeleteIcon />}
            color="error"
            onClick={handleDeleteSelected}
            disabled={!table.getSelectedRowModel().rows.length}
          >
            Delete
          </Button>
        </Box>
      </Box>

      <MaterialReactTable table={table} />
    </div>
  );
}
